import {
  MenuApprovalsIcon,
  MenuBudgetIcon,
  MenuSuppliersIcon,
  MenuPurchaseRequestsIcon,
  MenuOrdersIcon,
  MenuReportsIcon,
  MenuItemsIcon,
  MenuBooksIcon,
} from "components/icons/ProcurementMenuIcons"

// Same inactive/active colour convention as the rest of the sidenav
// (MenuHomeIcon, MenuCalendarIcon, ...): grey stroke when the item isn't the
// active route, blue stroke when it is.
const INACTIVE = "#ADB5BD"
const ACTIVE = "#1576BC"

const navIcon = (Icon) => ({
  icon: <Icon stroke={INACTIVE} />,
  iconActive: <Icon stroke={ACTIVE} />,
})

export const procurementNavIcons = {
  approvals: navIcon(MenuApprovalsIcon),
  budget: navIcon(MenuBudgetIcon),
  suppliers: navIcon(MenuSuppliersIcon),
  requests: navIcon(MenuPurchaseRequestsIcon),
  orders: navIcon(MenuOrdersIcon),
  report: navIcon(MenuReportsIcon),
  items: navIcon(MenuItemsIcon),
  books: navIcon(MenuBooksIcon),
}
